<template>
  <section
    class="component-home-banner text-center pt-md-5 chb-bg mt-lg-0 mt-md-5"
    :class="headingEnabled ? 'pt-3' : ''"
    resmed-component-name="home-banner"
    :style="{
      background: data.layout_options['background'],
      color: data.layout_options['color'],
      'background-image': 'url(' + data.background_image + ')',
      padding: '30px 0px',
      'background-size': 'cover',
    }"
  >
    <div class="component container-fluid px-xs-sm-2" :class="headingEnabled ? 'custom-border' : ''"  >
      <div class="container" v-if="headingEnabled" style="padding:20px;">
        <!-- <p class="intro mb-3 pt-lg-4 pt-3">{{ data.introduction }}</p> -->
        <h1 class="mb-3 text-white">{{ $getTranslation(data.heading, $route.params.region) }}</h1>
          <p class="col-12 col-md-12 col-lg-6 m-auto text-md" v-if="data.introduction">{{ data.introduction }}</p>
      </div>
      <div class="row pb-5 pb-md-0" :class="headingEnabled ? 'd-block' : 'd-md-block d-none'" style="margin:20px 0px;">
        <div class="col-md-10 col-lg-12 mx-auto">
          <search-form :showSearchIcon="headingEnabled" :options="data.all_products.products" listCat="true"></search-form>
        </div>
      </div>
      <!-- <div class="categories d-md-block d-none" style="background:#232323" > -->
        <!-- <span class="font-weight-bold"  v-if="data.all_products.heading !==''">{{ data.all_products.heading }} :</span> -->
        <!-- <span v-for="(product, i) in data.all_products.products">
          <a :href="product.href" :target="product.target" v-if="product.name == 'Philips Recall'" style="background:#000000; padding:18px;"> 
             {{ product.name }}  
          </a>
          <a :href="product.href" :target="product.target" v-else> 
             {{ product.name }}  
          </a>
          
          <span v-if="i != data.all_products.products.length - 1">|</span>
         
        </span> -->
      <!-- </div> -->
    </div>
  </section>
</template>
​
<script>
import { mapMutations } from 'vuex';
import navigationCard from "./navigation-card";
export default {
  name: "home-banner",
  props: ["data"],
  data() {
    return {
      siteRegion: "",
    }
  },
  computed: {
    headingEnabled() {
      return this.data.enabled[0] === "true";
    },
  },
  methods: {
    ...mapMutations(['setShowLinks']),
    // check the region
    isUk() {
      this.siteRegion = this.$route.params.region;
      return this.siteRegion;
    },
  },
  created() {
    this.setShowLinks(false)
  },
  mounted() {
    this.isUk();
  }
};


</script>
​
<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
.component-home-banner {
  .custom-border {
    @media (max-width: 550px) {
      border-top: 2px solid #fff;
      margin-top: 52px;
    }
  }
  .intro {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    &::before {
      content: "";
      display: block;
      width: 1.25rem;
      border-top: 3px solid #fff;
      border-radius: 5.5px;
      margin: -3px auto 16px;
    }
  }

  .categories {
    margin-top: 1rem;
    margin-right:-10px;
    margin-left:-10px;
    padding: 1rem;
    font-family: "Plus Jakarta Sans", Arial, sans-serif;
    a {
      color: #fff;
      cursor: pointer;
      padding: 0px 20px;
    }
  }

  .chb-bg{
    background-size: cover !important;
  }
}
</style>
